import { __module as u } from "./index771.js";
var $ = u.exports, k;
function q() {
  return k ? u.exports : (k = 1, (function(w, _) {
    (function(y, i) {
      w.exports = i();
    })($, (function() {
      return function(y, i, r) {
        var M = i.prototype, d = function(n) {
          return n && (n.indexOf ? n : n.s);
        }, t = function(n, e, s, l, f) {
          var a = n.name ? n : n.$locale(), p = d(a[e]), D = d(a[s]), c = p || D.map((function(h) {
            return h.slice(0, l);
          }));
          if (!f) return c;
          var v = a.weekStart;
          return c.map((function(h, x) {
            return c[(x + (v || 0)) % 7];
          }));
        }, o = function() {
          return r.Ls[r.locale()];
        }, m = function(n, e) {
          return n.formats[e] || (function(s) {
            return s.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(l, f, a) {
              return f || a.slice(1);
            }));
          })(n.formats[e.toUpperCase()]);
        }, S = function() {
          var n = this;
          return { months: function(e) {
            return e ? e.format("MMMM") : t(n, "months");
          }, monthsShort: function(e) {
            return e ? e.format("MMM") : t(n, "monthsShort", "months", 3);
          }, firstDayOfWeek: function() {
            return n.$locale().weekStart || 0;
          }, weekdays: function(e) {
            return e ? e.format("dddd") : t(n, "weekdays");
          }, weekdaysMin: function(e) {
            return e ? e.format("dd") : t(n, "weekdaysMin", "weekdays", 2);
          }, weekdaysShort: function(e) {
            return e ? e.format("ddd") : t(n, "weekdaysShort", "weekdays", 3);
          }, longDateFormat: function(e) {
            return m(n.$locale(), e);
          }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
        };
        M.localeData = function() {
          return S.bind(this)();
        }, r.localeData = function() {
          var n = o();
          return { firstDayOfWeek: function() {
            return n.weekStart || 0;
          }, weekdays: function() {
            return r.weekdays();
          }, weekdaysShort: function() {
            return r.weekdaysShort();
          }, weekdaysMin: function() {
            return r.weekdaysMin();
          }, months: function() {
            return r.months();
          }, monthsShort: function() {
            return r.monthsShort();
          }, longDateFormat: function(e) {
            return m(n, e);
          }, meridiem: n.meridiem, ordinal: n.ordinal };
        }, r.months = function() {
          return t(o(), "months");
        }, r.monthsShort = function() {
          return t(o(), "monthsShort", "months", 3);
        }, r.weekdays = function(n) {
          return t(o(), "weekdays", null, null, n);
        }, r.weekdaysShort = function(n) {
          return t(o(), "weekdaysShort", "weekdays", 3, n);
        }, r.weekdaysMin = function(n) {
          return t(o(), "weekdaysMin", "weekdays", 2, n);
        };
      };
    }));
  })(u), u.exports);
}
export {
  q as __require
};
